__turbopack_context__.v({
  "image": "storyHero-module-scss-module__sFPSea__image",
  "introduction": "storyHero-module-scss-module__sFPSea__introduction",
  "story_hero": "storyHero-module-scss-module__sFPSea__story_hero",
  "title": "storyHero-module-scss-module__sFPSea__title",
  "top": "storyHero-module-scss-module__sFPSea__top",
  "type": "storyHero-module-scss-module__sFPSea__type",
});
